import React from "react";

const ServingBox = React.memo(({ label, lastServed, isAnnouncing }) => {
  return (
    <div className="d-flex align-items-center mb-2" style={{ gap: "1rem" }}>
      <div
        className="text-white text-center fw-bold"
        style={{
          backgroundColor: "#2f6b2f",
          padding: "10px 20px",
          borderRadius: "8px",
          minWidth: "130px",
          fontSize: "0.9rem",
        }}
      >
        {label}
      </div>
      <div
        className="p-2 px-3 d-flex flex-column justify-content-center flex-grow-1"
        style={{
          borderRadius: "8px",
          minWidth: "250px",
          minHeight: "65px",
          boxShadow: "0 0 4px rgba(0,0,0,0.1)",
          backgroundColor: isAnnouncing ? "#d9822b" : "#ffffff",
          color: isAnnouncing ? "white" : "black",
          transition: "all 0.4s ease",
          transform: isAnnouncing ? "scale(1.1)" : "scale(1)",
        }}
      >
        {lastServed ? (
          <>
            <div
              className="fw-bold text-center"
              style={{ fontSize: isAnnouncing ? "1.2rem" : "1rem" }}
            >
              {lastServed.name}
            </div>
            <hr style={{ margin: "4px 0", borderTop: "2px solid #f2c59c" }} />
            <div
              className="text-muted text-center fw-bold"
              style={{ fontSize: "0.6rem" }}
            >
              {lastServed.positionApplied || lastServed.servedBy || "N/A"}
            </div>
          </>
        ) : (
          <div
            className="fst-italic text-muted text-center"
            style={{ fontSize: "0.6rem" }}
          >
            No one assigned
          </div>
        )}
      </div>
    </div>
  );
});

ServingBox.displayName = "ServingBox";

export default ServingBox;
